import i18next from 'i18next';
import { initReactI18next } from 'react-i18next'
import translationsEN from './translations_en.json';
import translationsKO from './translations_ko.json';
import translationsVI from './translations_vi.json';
import translationsZHCN from './translations_zh_cn.json';
import translationsZHTW from './translations_zh_tw.json';
import translationsJA from './translations_ja.json';
import translationsTH from './translations_th.json';
import translationsNE from './translations_ne.json';
import translationsES from './translations_es.json';
import translationsDE from './translations_de.json';
import translationsFR from './translations_fr.json';
import translationsPTBR from './translations_pt_br.json';
import translationsRU from './translations_ru.json';
import {getCachedQrCatalog, normalizeQrLocale} from './remoteCatalog';

const resources = {
  en: { translation: translationsEN },
  ko: { translation: translationsKO },
  vi: { translation: translationsVI },
  zh_cn: { translation: translationsZHCN },
  zh_tw: { translation: translationsZHTW },
  ja: { translation: translationsJA },
  th: { translation: translationsTH },
  ne: { translation: translationsNE },
  es: { translation: translationsES },
  de: { translation: translationsDE },
  fr: { translation: translationsFR },
  pt_br: { translation: translationsPTBR },
  ru: { translation: translationsRU }
};

const storedLanguage = localStorage.getItem('lang');
const langSelected = normalizeQrLocale(
  storedLanguage && storedLanguage !== 'undefined' ? storedLanguage : 'ko'
);
const cachedCatalog = getCachedQrCatalog(langSelected);
if (cachedCatalog?.translations) {
  resources[langSelected] = {
    translation: {
      ...(resources[langSelected]?.translation || {}),
      ...cachedCatalog.translations,
    },
  };
}

i18next.use(initReactI18next).init({
  lng: langSelected, // if you're using a language detector, do not define the lng option
  fallbackLng: 'ko',
  returnEmptyString: false,
  debug: process.env.NODE_ENV === 'development',
  resources
})

export default i18next;
